/**
 * page.Forms - delete-account — Shopify Forms는 Shadow DOM이라
 * 테마 CSS로 input 높이·box-sizing·필드 간격을 확정하기 어렵다.
 * shadowRoot에 스타일을 한 번 주입한다.
 */
(function () {
  const HOST_SELECTOR = 'main[data-template="page.Forms - delete-account"] shopify-forms-embed';
  const STYLE_ID = 'orr-delete-account-form-field-styles';

  const CSS = `
    /* 앱 기본 :host(450px/397px)보다 우선 — 컬럼 가로 100% */
    :host {
      --inline-container-max-width: 100% !important;
      --container-max-w: 100% !important;
      --app-embed-width: 100% !important;
    }
    form {
      display: flex;
      flex-direction: column;
      gap: 0;
      margin-block-start: 0 !important;
      padding-block-start: 0 !important;
    }
    /* 맨 위 인풋까지: lead-capture 블록 + 첫/둘째 행 래퍼의 앱 기본 margin 제거 */
    form > *:first-child {
      margin-block-start: 0 !important;
      margin-block-end: 0 !important;
    }
    form > *:first-child + * {
      margin-block-start: 0 !important;
    }
    form shop-lead-capture {
      display: block !important;
      margin: 0 !important;
      min-height: 0 !important;
    }
    /* 마지막 인풋 묶음 ~ 탈퇴 사유(체크박스 등): 블록 간 40px (블록 내부 패딩은 앱 설정) */
    form > fieldset {
      margin-block-start: 40px !important;
    }
    /* 탈퇴 사유 textarea ~ 제출 버튼: 40px (구조별) */
    form > textarea:last-of-type {
      margin-block-end: 40px !important;
    }
    form > fieldset:has(textarea) {
      margin-block-end: 40px !important;
    }
    form > div:has(textarea) {
      margin-block-end: 40px !important;
    }

    /* 상단 문구만 좌측 — #form-container-ref 전체 text-align은 필드 레이아웃에 영향 줄 수 있어 제외 */
    #form-container-ref h1,
    #form-container-ref h2,
    #form-container-ref h3 {
      text-align: left !important;
    }
    #form-container-ref p {
        text-align: left !important;
        font-family: var(--typo-body-primary-regular-font-family);
        font-weight: var(--typo-body-primary-regular-font-weight);
        font-size: var(--typo-body-primary-regular-font-size);
        line-height: var(--typo-body-primary-regular-line-height);
        letter-spacing: var(--typo-body-primary-regular-letter-spacing);
        color: var(--color-text-primary);
    }

    input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="image"]):not([type="file"]),
    textarea {
      box-sizing: border-box !important;
    }
    /* 인필드 라벨이 상단을 차지 — 상단 패딩으로 입력 첫 줄이 라벨과 겹치지 않게 */
    input[type="text"],
    input[type="email"],
    input[type="tel"],
    input[type="url"],
    input[type="search"],
    input[type="number"],
    input[inputmode="numeric"],
    input[inputmode="tel"],
    input[inputmode="email"] {
      min-height: 56px !important;
      padding-block-start: 22px !important;
      padding-block-end: 12px !important;
      padding-inline: 14px !important;
      line-height: normal !important;
    }
    textarea {
      min-height: 100px !important;
      height: auto !important;
      max-height: none !important;
      padding-block-start: 30px !important;
      padding-block-end: 12px !important;
      padding-inline: 14px !important;
      line-height: normal !important;
    }
    /* 전화번호 국가 선택 토글 — 해시 클래스 대신 aria-controls */
    button[aria-controls="country-selector-dropdown"],
    button[aria-controls*="country-selector"] {
      box-sizing: border-box !important;
      min-height: 56px !important;
    }
    /* 국가 선택 + 국가번호(+82)가 있는 행: 플레이스홀더와 겹침 방지 */
    form:has(button[aria-controls="country-selector-dropdown"]) input[type="tel"],
    form:has(button[aria-controls*="country-selector"]) input[type="tel"],
    form:has(button[aria-controls="country-selector-dropdown"]) input[inputmode="tel"],
    form:has(button[aria-controls*="country-selector"]) input[inputmode="tel"] {
      padding-inline-start: 3.5rem !important;
    }
    /* 체크박스: Title/Sub_secondary = legend, Body/Body_primary = 항목 (theme-styles-variables) */
    fieldset:has(input[type="checkbox"]) > legend {
      font-family: var(--font-heading, inherit) !important;
      font-weight: 700 !important;
      font-size: 14px !important;
      line-height: 120% !important;
      letter-spacing: 0.2em !important;
    }
    fieldset:has(input[type="checkbox"]) label {
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      cursor: pointer !important;
      font-family: var(--font-body, inherit) !important;
      font-weight: 400 !important;
      font-size: 16px !important;
      line-height: 120% !important;
      letter-spacing: 0.02em !important;
      color: var(--color-primary, rgb(32, 32, 32)) !important;
    }
    @media screen and (min-width: 1024px) {
      fieldset:has(input[type="checkbox"]) label {
        font-size: 14px !important;
      }
    }
    fieldset:has(input[type="checkbox"]) label:has(input[type="checkbox"]:disabled) {
      cursor: not-allowed !important;
      color: var(--input-disabled-text-color, #7d7d7d) !important;
    }
    fieldset:has(input[type="checkbox"]) input[type="checkbox"] {
      appearance: none !important;
      -webkit-appearance: none !important;
      position: relative !important;
      width: 24px !important;
      height: 24px !important;
      min-width: 24px !important;
      min-height: 24px !important;
      margin: 0 !important;
      border-radius: 1px !important;
      box-sizing: border-box !important;
      border: 1px solid var(--color-gray-2, #dbdbdb) !important;
      background-color: var(--color-background, rgb(255, 255, 255)) !important;
      flex-shrink: 0 !important;
      cursor: pointer !important;
    }
    fieldset:has(input[type="checkbox"]) input[type="checkbox"]::after {
      content: '' !important;
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      width: 15px !important;
      height: 10px !important;
      transform: translate(-50%, -50%) !important;
      opacity: 0 !important;
      background-image: url("data:image/svg+xml,%3Csvg width='15' height='10' viewBox='0 0 15 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.710938 3.22656L5.71094 8.22656L13.7109 0.726562' stroke='%23202020' stroke-width='2'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
      background-size: 15px 10px !important;
      transition: opacity var(--animation-speed, 0.2s) var(--animation-easing, ease) !important;
    }
    fieldset:has(input[type="checkbox"]) input[type="checkbox"]:checked {
      border-color: var(--color-gray-2, #dbdbdb) !important;
      background-color: var(--color-background, rgb(255, 255, 255)) !important;
    }
    fieldset:has(input[type="checkbox"]) input[type="checkbox"]:checked::after {
      opacity: 1 !important;
    }
    fieldset:has(input[type="checkbox"]) input[type="checkbox"]:focus-visible {
      outline: var(--focus-outline-width, 2px) solid var(--color-primary, rgb(32, 32, 32)) !important;
      outline-offset: -1px !important;
    }
    fieldset:has(input[type="checkbox"]) label:hover input[type="checkbox"]:not(:disabled) {
      outline: var(--focus-outline-width, 2px) solid var(--color-primary, rgb(32, 32, 32)) !important;
      outline-offset: -1px !important;
    }
    fieldset:has(input[type="checkbox"]) input[type="checkbox"]:disabled {
      cursor: not-allowed !important;
      background-color: var(--input-disabled-background-color, #f5f5f5) !important;
      border-color: var(--input-disabled-border-color, #dbdbdb) !important;
    }
    /* 탈퇴 신청 버튼: 284×60, padding 20px, Title/Sub_category (theme-styles-variables) */
    form button[type="submit"] {
      box-sizing: border-box !important;
      width: 284px !important;
      max-width: 100% !important;
      min-height: 48px !important;
      padding: 14px 20px !important;
      font-family: var(--font-heading, inherit) !important;
      font-weight: 400 !important;
      font-size: 13px !important;
      line-height: 180% !important;
      letter-spacing: 0.2em !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    @media screen and (max-width: 1023px) {
      form button[type="submit"] {
        width: 100% !important;
        max-width: 100% !important;
      }
    }
  `.trim();

  /**
   * @param {ShadowRoot} root
   */
  function injectIntoShadow(root) {
    if (!root) return;
    let style = root.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.appendChild(style);
    }
    style.textContent = CSS;
  }

  /**
   * @param {Element & { shadowRoot?: ShadowRoot | null }} host
   */
  function processHost(host) {
    if (host.shadowRoot) {
      injectIntoShadow(host.shadowRoot);
      return;
    }
    let attempts = 90;
    const tick = () => {
      if (host.shadowRoot) {
        injectIntoShadow(host.shadowRoot);
        return;
      }
      if (--attempts <= 0) return;
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  function scan() {
    document.querySelectorAll(HOST_SELECTOR).forEach(processHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
